import {customAxiosBE} from "../config";

export async function getAllOperationalIntervalAPI(payload) {
    return customAxiosBE.get(`/operationalInterval?page=${payload.page}&size=${payload.rowsPerPage}`)
}

export async function getOperationalIntervalAPI(id) {
    return customAxiosBE.get(`/operationalInterval/${id}`)
}

export async function getAllOperationalIntervalsForDiscountsAPI() {
    return customAxiosBE.get(`/operationalInterval?page=0&size=1000`)
}

